import React from 'react';
import '../ConfirmationDialog/for_confirmation.scss';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Divider, Stack, Typography } from '@mui/material';

const InvalidDeviceBannerSvg = ({ size = 44 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M32 6.5c10.7 6.6 19.8 6.6 23.5 6.6v18.6c0 15.6-10.5 24.7-23.5 28.8C19 56.4 8.5 47.3 8.5 31.7V13.1c3.7 0 12.8 0 23.5-6.6Z"
        stroke="currentColor"
        strokeWidth="3"
        opacity="0.9"
      />
      <path
        d="M32 19v18"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M32 45.5h.01"
        stroke="currentColor"
        strokeWidth="6"
        strokeLinecap="round"
      />
    </svg>
  );
};

const InvalidDeviceDialog = ({ open, title, message, onLogout }) => {
  return (
    <Dialog
      open={open}
      onClose={() => {}}
      aria-labelledby="invalid-device-dialog-title"
      aria-describedby="invalid-device-dialog-description"
      className='DRM'
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: 2,
          overflow: 'hidden',
          maxWidth: 520,
          width: 'calc(100% - 32px)',
        },
      }}
    >
      <DialogTitle id="invalid-device-dialog-title" className='alert-TitleCl' sx={{ pb: 0.5 }}>
        {title || 'Invalid Device'}
      </DialogTitle>
      <DialogContent>
        <Stack direction="row" spacing={2} sx={{ pt: 1 }} alignItems="flex-start">
          <Box
            sx={{
              color: '#2575fc',
              background: 'rgba(37, 117, 252, 0.08)',
              borderRadius: 2,
              p: 1.25,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <InvalidDeviceBannerSvg />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <DialogContentText id="invalid-device-dialog-description" className='alert-titleContent'>
              {message || 'Invalid device. Please login again.'}
            </DialogContentText>
            <Typography
              variant="body2"
              sx={{
                mt: 0.75,
                color: 'text.secondary',
                fontFamily: '"Public Sans", sans-serif',
              }}
            >
              You will be redirected to login after logout.
            </Typography>
          </Box>
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button className='buttonClassname' onClick={onLogout} autoFocus fullWidth>
          Logout
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InvalidDeviceDialog;
